export const CURRENT_USER_QUERY_KEY = ["auth", "currentUser"] as const;
